/**
 * Common schemas shared across all API contracts
 */

import { z } from "zod";

/**
 * Standard error response schemas
 */
export const errorResponseSchema = z.object({
  statusCode: z.number(),
  message: z.string(),
  error: z.string().optional(),
});

export const validationErrorSchema = z.object({
  statusCode: z.literal(400),
  message: z.string(),
  errors: z
    .array(
      z.object({
        path: z.array(z.string()),
        message: z.string(),
      })
    )
    .optional(),
});

export const unauthorizedErrorSchema = z.object({
  statusCode: z.literal(401),
  message: z.string(),
});

export const forbiddenErrorSchema = z.object({
  statusCode: z.literal(403),
  message: z.string(),
});

export const notFoundErrorSchema = z.object({
  statusCode: z.literal(404),
  message: z.string(),
});

export const internalErrorSchema = z.object({
  statusCode: z.literal(500),
  message: z.string(),
});

/**
 * Standard error responses for all endpoints
 */
export const standardErrors = {
  400: validationErrorSchema,
  401: unauthorizedErrorSchema,
  403: forbiddenErrorSchema,
  404: notFoundErrorSchema,
  500: internalErrorSchema,
};

/**
 * Pagination schemas
 */
export const paginationQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(20),
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).default("asc"),
});

export const paginationMetaSchema = z.object({
  page: z.number(),
  limit: z.number(),
  total: z.number(),
  totalPages: z.number(),
  hasNext: z.boolean(),
  hasPrevious: z.boolean(),
});

/**
 * Common field schemas
 */
export const idSchema = z.string().min(1);
export const timestampSchema = z.string().datetime();
export const emailSchema = z.string().email();
export const urlSchema = z.string().url();
export const uuidSchema = z.string().uuid();

/**
 * Health check schema
 */
export const healthCheckResponseSchema = z.object({
  status: z.literal("ok"),
  timestamp: timestampSchema,
  uptime: z.number(),
  service: z.string(),
});
